import axios from 'axios'

const state = {
  isAssetsFetch: false,
  assets: []
}

const actions = {
  fetch_assets({state, commit}){
    return axios({
      method: 'GET',
      url: process.env.VUE_APP_ASSET_URL + '/companies.json'
    })
    .then((res) => {
      commit("set_is_assets_fetch", true)
      commit("set_assets", res.data)
    })
    .catch((err) => {
      console.error(err)
    })
  }
}

const mutations = {
  set_is_assets_fetch: (state, isAssetsFetch) => {
    state.isAssetsFetch = isAssetsFetch
  },
  set_assets: (state, assets) => {
    state.assets = assets
  },
}

const getters = {
  get_company_tel(state){
    if(!state.isAssetsFetch){
      return '';
    }
    return state.assets[0].Tel;
  },

  get_company_email(state){
    if(!state.isAssetsFetch){
      return '';
    }
    return state.assets[0].Email;
  },

  get_company_address(state){
    if(!state.isAssetsFetch){
      return '';
    }
    return state.assets[0].Address;
  },

  get_consultant_portal_app_setting(state){
    let appSetting;
    if(state.isAssetsFetch){
      state.assets[0].AppSettings.forEach(appSettingFromApi => {
          if(appSettingFromApi.AppName == "Consultant Portal"){
              appSetting = appSettingFromApi;
          }
      });
    }
    return appSetting;
  },

  get_company_logo: (state, getters) => (colorType) => {
      let companyLogo;
      if(state.isAssetsFetch){
        getters.get_consultant_portal_app_setting.Logo.forEach(logo => {
            if(logo.Type == colorType){
                companyLogo = logo.Url;
            }
        });
      }
      return companyLogo;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
